<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/notify/">Notifications</a></li>
      <li class="breadcrumb-item active" aria-current="page">Create Notification</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
              <label class="text-black mb-3"><b>Notification</b></label>
              <div class="row">
                <div class="col-md-5">
                  <div class="required">
              <div class="form-group">
                <label class="control-label" for="type">Type</label>
                <input type="text" id="type" onkeypress='return event.charCode >= 48 && event.charCode <= 57 || event.charCode = 32  || event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122' id="type" [(ngModel)]="type" rows="1" maxlength="30"
                       class="form-control" (blur)="TypeStatusText()" [ngClass]="{'is-invalid':typeStatusText}" [ngModelOptions]="{standalone: true}" required/>
                <div id="typeStatusText" class="invalid-feedback d-block shift-invalid-login" style="position:absolute" [hidden]="!typeStatusText">{{typeStatusText}}</div>
              </div>
            </div>
                  <div id="statusText" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText">{{statusText}}</div>
                </div>
                </div>
              </div>
          </div>
        </div>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black mb-3">Reason</h2>
          <div class="row">
            <div class="col-md-5">
              <div class="required">
                <label for="description" class="control-label" style="font-size:11px">Message/Reason to Specify</label>
                <textarea id="description" id="message" onkeypress='return event.charCode >= 48 && event.charCode <= 57 || event.charCode = 32 || event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32 ' [(ngModel)]="description" rows="6"  maxlength="250"
                          class="form-control" (blur)="DescStatusText()" [ngClass]="{'is-invalid':descStatusText}" [ngModelOptions]="{standalone: true}" required></textarea>
              </div>
              <div id="descStatusText" class="invalid-feedback d-block shift-invalid-login" [hidden]="!descStatusText">{{descStatusText}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
  <div class="col-12 text-right">
    <button type="submit" class="btn btn-cancel-prime" id="cancel" routerLink="/admin/notify">Cancel</button>
    <button type="submit" class="btn btn-orange-prime ml-2" id="submit" (click)="submitNotify()">Submit</button>
  </div>
</div>
</div>
